import { ServicePage } from "@/components/ServicePage";
import { SERVICE_PAGES } from "@/data/content";

export default function Hochsteckfrisuren() {
  return <ServicePage page={SERVICE_PAGES.braut} />;
}
